import { Pipe, PipeTransform } from '@angular/core';
import { StatusDetalheConferencia } from '../../enum/StatusDetalheConferencia';
import { RespostasCriticasSolucoesDetalhesCabecalhosConferenciasDeFaturasDTO as Critica } from '../../models/conferencia-de-fatura/DetalheBeneficiarioConferenciaDeFatura';

@Pipe({
  name: 'badgeStatusDetalheConferenciaDeFatura',
})
export class BadgeStatusDetalheConferenciaDeFaturaPipe
  implements PipeTransform
{
  transform(criticas: Critica[]): string {
    const temCritica = criticas.length && criticas.some(
      (critica) => critica.respostaCriticaConferenciaDeFaturaDTO?.codigo
    );
    const todasCriticasResolvidas = criticas.every(
      (critica) => critica.respostaSolucaoConferenciaDeFaturaDTO?.codigo
    );
    

    if (!temCritica) {
      return 'bg-primary-subtle text-primary';
    }

    if (todasCriticasResolvidas) {
      return 'text-success bg-green';
    }

    return 'text-danger bg-red';
  }
}
